// frontend/src/api/client.js
import axios from "axios";
import API_BASE_URL from "../config";

// Create Axios instance
const client = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: false,
});

// Request interceptor → attach token if present
client.interceptors.request.use((config) => {
  try {
    const requestUrl = `${config.url || ""}`;
    const adminToken = localStorage.getItem("admin-token");
    if (adminToken && requestUrl.includes("/api/admin")) {
      config.headers.Authorization = `Bearer ${adminToken}`;
      return config;
    }

    const sellerToken = localStorage.getItem("seller-token");
    if (sellerToken && !requestUrl.includes("/api/customers")) {
      config.headers.Authorization = `Bearer ${sellerToken}`;
      return config;
    }

    if (adminToken) {
      config.headers.Authorization = `Bearer ${adminToken}`;
      return config;
    }

    const stored = localStorage.getItem("customer");
    if (stored) {
      const customer = JSON.parse(stored);
      if (customer?.token) {
        config.headers.Authorization = `Bearer ${customer.token}`;
      }
    }

  } catch (err) {
    console.error("Token parsing error:", err);
  }
  return config;
});

// Response interceptor → auto-logout on 401
client.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      try {
        localStorage.removeItem("customer");
        localStorage.removeItem("admin-token");
        localStorage.removeItem("seller");
        localStorage.removeItem("seller-token");
      } catch {}
    }
    return Promise.reject(err);
  }
);

export default client;
